import {Component, effect, EventEmitter, inject, input, OnDestroy, Output, signal} from '@angular/core';
import {AuthService} from "../../../shared/services/auth.service";
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";
import {filter, interval, of, Subject, switchMap, take, takeUntil, tap} from "rxjs";
import {Router} from "@angular/router";
import {TranslateModule} from "@ngx-translate/core";
import {CallPassword} from "../../../shared/interfaces/auth";
import {JsonPipe} from "@angular/common";

@Component({
  selector: 'app-newtel',
  imports: [
    TranslateModule,
    JsonPipe
  ],
  templateUrl: './newtel.component.html',
  styleUrl: './newtel.component.scss'
})
export class NewtelComponent {

  @Output() 'showNewPassword' = new EventEmitter();
  @Output() 'successPhoneUpdate' = new EventEmitter();

  private $auth = inject(AuthService);
  private $router = inject(Router);

  newTelData = input<CallPassword | null>();
  callPassword = this.$auth.callPassword || this.newTelData;
  is_recovery = this.$auth.is_recovery;
  tel = input.required<string | null>();
  updatePhone = input(false);

  constructor() {
    effect(()=> {
      const newTelData = this.newTelData();
      if (newTelData) {
        this.callPassword.set(newTelData);
      }
    })
    interval(3000)
      .pipe(
        takeUntilDestroyed(),
        switchMap(() => {
          if (this.is_recovery()) return this.$auth.checkCallResetPasswordStatus();
          if (this.updatePhone()) return this.$auth.checkCallUpdatePhoneStatus();
          return this.$auth.checkCallPasswordStatus();
        }),
        filter(res => res.status === 'confirmed'),
        take(1), // Останавливаем поток после первого подтверждения
        switchMap(() => {
          if (this.is_recovery()) return this.$auth.callResetPasswordVerify();
          if (this.updatePhone()) return this.$auth.callUpdatePhoneVerify();
          return this.$auth.callPasswordVerify();
        }),
        tap(() => {
          if (this.is_recovery()) {
            this.showNewPassword.emit();
            return;
          }
          if (this.updatePhone()) {
            this.successPhoneUpdate.emit();
            return;
          }
          this.$router.navigate(['/answer'])
        })
      )
      .subscribe();
  }
}
